import { Observable, of } from "rxjs";
import { first, map, mergeMap } from "rxjs/operators";
import { Circulation, Step, UserId } from ".";
import { AbstractAuthorizationService } from "../authorization/services/abstractAuthorization.service";
import { UserFacade } from "../user/services/user.facade";

export interface IHyperlinkToSave {
  name: string;
  uri: string;
}
export interface IDocument {
  id: string;
  isHyperlink: boolean;
  name: string;
  uri: string;
  stepNo: number;
  uploadedBy: UserId;
}

export class Document {
  constructor(
    public doc: IDocument,
    private circ: Circulation,
    private currentStep: Step,
    private userFacade: UserFacade,
    private authorizationService: AbstractAuthorizationService
  ) {}

  public canDelete(): Observable<boolean> {
    const user = this.userFacade.getUser();

    if (
      this.doc.stepNo > 0 &&
      this.currentStep?.props?.stepNo === this.doc.stepNo
    ) {
      // check if user can delete this document
      return user.pipe(
        first(),
        map((u) => u.id === this.doc.uploadedBy || this.authorizationService.isAdmin(u.roles))
      );
    }

    // do the normal admin || owner check.
    return user.pipe(
      first(),
      mergeMap((u) => {
        const isAdmin = this.authorizationService.isAdmin(u.roles);
        if (isAdmin) {
          return of(true);
        }
        else {
          return this.circ.canStart(u, isAdmin);
        }
      }
      )
    );
  }
}

export interface IDocumentUploadEndpoints {
  removeUrl: string;
  saveUrl: string;
  restrictions: { allowedExtensions?: string[]; maxFileSize?: number, minFileSize?: number };
}
